import React from "react";
import {appRoutePaths, miscImages} from "../../../../config/config";
import {useNavigate} from "react-router-dom";
import BasicPage from "../../../common/basicPage/BasicPage";
import {displayErrorToUser} from "../../../../services/error/error";
import {microphone} from "../../../../hooks/microphone.hook";
import {logger} from "../../../../services/log/logger";

interface IAllowMicrophoneAccessProps {
}

export default function AllowMicrophoneAccess({}: IAllowMicrophoneAccessProps) {
  const navigate = useNavigate();
  const headerTextContent: string = 'Allow microphone access for feedback';

  // If the user has already granted microphone access don't need to show this page, so go to You're All Set page
  microphone.checkPermissions(false)
    .then((status) => {
      if (status === "granted") {
        navigate(appRoutePaths.onboarding_setupFeedback_youAreAllSet);
      }
    })
    .catch((error) => {
      displayErrorToUser("An error occurred while checking microphone permissions.");
      logger.microphone.error({ message: "Error checking microphone permissions:", error });
    });

  return (
    <BasicPage
      headerIcon={miscImages.whiteMicrophone}
      portraitModeHeaderText={headerTextContent}
      content={
        <>
          <h1>{headerTextContent}</h1>
          <p>To provide feedback using your device&apos;s microphone, tap Request Mic Access below and then Allow on the message displayed afterward.</p>
          <small>
            Microphone recordings do not leave your device and are deleted after your score is presented.
          </small>
        </>
      }
      actionButton={{
        text: "Request mic access",
        onClick: () => {
          microphone.getAccess({ audio: true, video: false })
            .then((stream) => {
              // cleanup
              stream.getTracks().forEach(track => track.stop()); // clean up
              navigate(appRoutePaths.onboarding_setupFeedback_youAreAllSet, {replace: true});

            })
            .catch((error) => {
              if (error.name === 'NotAllowedError' || error.name === 'PermissionDeniedError') {
                navigate(appRoutePaths.onboarding_setupFeedback_micAccessNeeded, {replace: true});
                return false;
              }
              displayErrorToUser("An error occurred requesting microphone access.");
              console.error("Error requesting microphone access:", error);
            });
        },
        buttonType: "secondary",
      }}
    />
  );
}
